import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 =
  "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech1_0ab00600de.webp";
const OJLImg2 = "https://cdn.msu.edu.in/medium_Trainee_9f1a7b0249.webp";
const OJLImg3 = "https://cdn.msu.edu.in/medium_Subba_3ecad8c763.webp";
const OJLImg4 = "https://cdn.msu.edu.in/medium_Pema_Nam_7c96ae1709.webp";
const OJLImg5 = "https://cdn.msu.edu.in/medium_Sarala_Pandey_0efd209edd.webp";
const OJLImg6 = "https://cdn.msu.edu.in/medium_Kabita_0f8468e819.webp";

const Img1 = "https://cdn.msu.edu.in/Whats_App_Image_2026_02_11_at_11_08_30_AM_c5b631cf80.jpeg";
const Img2 = "https://cdn.msu.edu.in/DSC_09118_d9f07975b9.JPG";
const Img3 = "https://cdn.msu.edu.in/EMT_4_f616818185.png";
const Img4 = "https://cdn.msu.edu.in/MLT_industry_learning_3_546acada54.jpg";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";

export const nutritionAndDietetics = {
  heroSection: {
    breadcrumb: [
      { name: "Home", url: "/" },
      {
        name: "Industry Co-led UG Programmes",
        url: "/industry-co-led-ug-programmes",
      },
      { name: "Bachelor in Nutrition and Dietetics", url: "" },
    ],
    bannerImg: "https://img.youtube.com/vi/pkv9d1kZcDQ/hqdefault.jpg",
    title: "Bachelor in Nutrition and Dietetics with Honours",
    poweredBy: {
      text: "Industry Skilling Partner",
      logo: EMVERSITY,
    },
    duration: "4 Year Undergraduate Degree Programme",
    description:
      "Learn about Medical Nutrition Therapy, Clinical Dietetics, Nutritional Assessment, Community Nutrition & Public Health, Sports Nutrition, Food Safety & Quality Control and more in the healthcare and wellness sector.",

    stats: [
      {
        value: "Up to 70%",
        label: "Hands-on training",
      },
      {
        value: "Paid",
        label: "On-the-job learning",
      },
      {
        value: "100%",
        label: "Placement Assistance",
      },
    ],

    buttons: {
      download: "Download Brochure",
      enroll: "Enroll Now",
    },

    video: {
      thumbnail: "https://img.youtube.com/vi/pkv9d1kZcDQ/hqdefault.jpg",
      buttonText: "Watch Programme Video",
      url: "https://www.youtube.com/embed/pkv9d1kZcDQ",
    },
  },

  aboutSection: {
    tag: "ABOUT THE PROGRAMME",
    title: "A Degree Designed for Clinical Nutrition & Health Impact",
    description: [
      "The Bachelor in Nutrition and Dietetics with Honours prepares students to assess, manage, and optimise nutritional health across clinical and community settings. The program combines biomedical and food science foundations with specialised training in medical nutrition therapy, diet planning, and therapeutic interventions.",
      "Through practical training, clinical exposure, and structured hospital internships, students develop the technical expertise and applied skills required in hospitals, wellness centres, and public health programmes. Graduates are equipped to deliver evidence-based nutritional care, improve patient outcomes, and promote healthier lifestyles across diverse populations.",
    ],
    stats: [
      { value: "Up to 70%", label: "Hands-on training" },
      { value: "Paid", label: "On-the-job learning" },
      { value: "100%", label: "Placement Assistance" },
    ],
    approvals: [
      "UGC Approved",
      "NEP 2020 Aligned",
      "Govt. Scholarships Available",
    ],
    journeyTitle: "Your 4-Year Journey",
    journey: [
      {
        phase: "YEAR 1",
        title: "Foundations in Food & Biomedical Sciences",
        description:
          "Human anatomy, biochemistry, food science, and introduction to nutrition ",
      },
      {
        phase: "YEAR 2",
        title: "Core Optometric Sciences",
        description:
          "Nutritional assessment, community nutrition, meal planning, and medical nutrition therapy",
      },
      {
        phase: "YEAR 3",
        title: "Advanced Dietetics & Specialisations",
        description:
          "Clinical dietetics, sports nutrition, therapeutic nutrition, and hospital-based rotations",
      },
      {
        phase: "YEAR 4",
        title: "Clinical Practice & Professional Readiness",
        description:
          "Advanced clinical nutrition, internships, research project, and industry readiness",
      },
      {
        phase: "GRADUATE",
        title: "Bachelor in Nutrition and Dietetics with Honours",
        description: "Industry-ready nutrition and dietetics professional",
      },
    ],
  },

  offeringSection: {
    tag: "OUR OFFERING",
    title: {
      first: "Comprehensive",
      highlight: "Nutrition & Dietetics Education",
    },
    description:
      "We offer a UGC-recognised, full-time undergraduate degree, Bachelor in Nutrition and Dietetics with Honours at Medhavi Skills University, Sikkim. It is an industry-aligned allied healthcare program designed to build strong clinical and applied nutrition skills, preparing students for impactful roles across healthcare, wellness and public health sectors.",
    learningBox: {
      title: "Key Areas of Learning",
      points: [
        "Basics of Food Science",
        "Nutrition Through Life Cycle",
        "Advanced Food Science",
        "Micronutrients in Human Nutrition",
        "Sports Nutrition",
        "Sustainable Food Systems"
      ],
    },
    image: "https://cdn.msu.edu.in/SH_937414395f.webp",
  },

  whyEMT: {
    tag: "WHY NUTRITION AND DIETETICS. WHY NOW.",
    title: "The New Frontier of Preventive Healthcare",
    description:
      "Our curriculum addresses the massive shift from reactive treatment to proactive wellness. As lifestyle-related metabolic disorders reach a critical peak, the Dietician has emerged as the primary architect of India's long-term public health.",
    stats: [
      {
        value: "$11.5 Billion",
        text: "Valuation of the Indian Nutraceutical Market. Projected to hit this milestone by 2030, the sector’s growth is fueled by a health-conscious population. This has created an unprecedented demand for specialists who can bridge the gap between traditional food and science-backed supplements.",
      },
      {
        value: "560 Million",
        text: "Indians expected to adopt healthier lifestyles by 2026. Driven by national movements like Fit India and POSHAN Abhiyaan, there is a massive surge in citizens seeking professional guidance. This shift has turned dietetics from a niche hospital service into a mainstream consulting powerhouse.",
      },
      {
        value: "11.3%",
        text: "Growth in India's Health & Wellness Coaching. As the IT workforce and urban populations pivot toward \"Food as Medicine,\" the need for certified experts to lead corporate wellness and digital health platforms is skyrocketing. Professionals who can manage metabolic health are now the industry's most essential assets.",
      },
    ],
  },

  msuAdvantages: {
    tag: "MSU ADVANTAGES",
    title: "Programme by Emversity, Delivered at MSU Campus",
    description:
      "Where academic excellence meets the operational demands of the modern allied and healthcare industry.",
    cards: [
      {
        number: "01",
        text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning",
      },
      {
        number: "02",
        text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships",
      },
      {
        number: "03",
        text: "Well-equipped simulation labs, advanced training setups and hands-on field training",
      },
    ],
    pointerTitle: "Highlights from The Programme",
    highlights: [
      "Programme aligned with NEP2020, focused in Learning Outcome Based Education",
      "Up to 70% practical based curriculum",
      "Paid On-the-job Learning",
      "Industry-aligned curriculum & hands-on learning",
      "Learn from seasoned professionals",
      "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
      "Chance to ‘learn and earn’ through immersive on-the-job learning, industry projects and internships with leading companies",
      "Engage with industry experts to get invaluable insights and real-world perspectives",
    ],
    image: "https://cdn.msu.edu.in/DSC_09111_25456de4fc.JPG",
  },

  CTA: {
    title: "Start Your Journey in Preventive Healthcare with  Emversity's",
    highlights: "Bachelor in Nutrition and Dietetics with Honours",
    url: "#",
    btnName: "Apply Now",
  },

  onJobtrainningData: {
    tag: "ON-THE-JOB LEARNING",
    title: "Practical Industry Exposure",
    description:
      "Our On-the-job Learning (OJL) enables students to gain real industry experience and earn a stipend while you gain your degree.",
    images: [
      { id: 1, src: OJLImg1, alt: "Pranita Pradhan at CRH Manipal, Gangtok" },
      {
        id: 2,
        src: OJLImg2,
        alt: "Kunsang Dolma Tamang at Mukherjee Hospital, Siliguri",
      },
      {
        id: 3,
        src: OJLImg3,
        alt: "Sancha Rani Subba at Anukul Diagnostic, Namchi",
      },
      {
        id: 4,
        src: OJLImg4,
        alt: "Pema Namgyal Bhutia at Ruchi Diagnostic, Gangtok",
      },
      {
        id: 5,
        src: OJLImg5,
        alt: "Sarala Pandey at District Hospital, Singtam",
      },
      {
        id: 6,
        src: OJLImg6,
        alt: "Kabita Karki at Prashanti Diagnostic, Singtam",
      },
    ],
  },

  addtionSkill: {
    courseSections: {
      AdditionalSkills: {
        tag: "BONUS CERTIFICATIONS",
        title: "Additional Skills Certifications",
        description:
          "Students will have the opportunity to build specialised skills that set them apart in the competitive healthcare and wellness industry. These credentials, earned alongside your degree, strengthen clinical competence, enhance professional credibility, and prepare you for roles with leading national and international healthcare and nutrition organisations.",
        image: {
          url: "https://cdn.msu.edu.in/small_ADP_7801_1_08a87168b2.jpg",
          alternativeText: "Skill Certification",
        },
        items: [
          {
            id: 1,
            text: "Cambridge English for Healthcare Professionals as per CEFR Standards",
            icon: Icon1,
          },
          {
            id: 2,
            text: "Food Safety, Quality & Regulatory Compliance (FSSAI-Aligned)",
            icon: Icon2,
          },
          { id: 3, text: "Nationally & Globally Recognised", icon: Icon1 },
        ],
        button: { text: "Apply Now", link: "/apply" },
      },
    },
  },

  DoExperienceLearndata: {
    tag: "INFRASTRUCTURE",
    title: "Do-Experience-Learn",
    description:
      "Discover the advantage of MSU’s cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities",
    images: [
      { id: 1, src: Img1, size: "large", alt: "Classrooms" },
      { id: 2, src: Img2, size: "large", alt: "Optometry Labs" },
      { id: 3, src: Img3, size: "small", alt: "Phoropters" },
      { id: 4, src: Img4, size: "small", alt: "Eye Testing Equipments" },
      { id: 5, src: Img5, size: "small", alt: "Virtual Campus Tour" },
    ],
  },

  studentStoriesData: {
    title: "Medhavians Speak",
    subText: "Real journeys of action and achievement.",
    students: [
      {
        name: "Radhika Chettri",
        image: Student2,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4",
      },
      {
        name: "Pratik Chettri",
        image: Student3,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4",
      },
      {
        name: "Suhana Sharma",
        image: Student4,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4",
      },
      {
        name: "Hissey Bhutia",
        image: Student1,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4",
      },
    ],
  },

  eligibility: {
    tag: "ELIGIBILITY",
    title: "Who Can Apply?",
    description:
      "10+2 (Any Stream) with 50% Aggregate with Physics, Chemistry and Biology/Mathematics as core subjects",
    button: { text: "Apply Now", url: "" },
    items: [
      {
        title: "12th Pass - Science Stream",
        text: "Candidates who have passed 10+2 with Physics, Chemistry and Biology/Mathematics as core subjects are eligible to apply for the Bachelor of Optometry programme.",
      },
    ],
  },

  careerProspects: {
    tag: "CAREER PROSPECTS",
    heading: "Career Prospects",
    description:
      "The Bachelor in Nutrition and Dietetics with Honours opens doors to diverse roles across hospitals, wellness platforms, public health systems, and the food and nutrition industry.",
    roles: [
      "Clinical Dietitian (Hospital)",
      "Community Nutritionist / Public Health Nutrition Officer",
      "Sports Nutritionist / Fitness & Performance Consultant",
      "Therapeutic Diet Specialist",
      "Food Service Manager / Institutional Diet Planner",
      "Corporate Wellness Consultant",
      "Nutrition Researcher / Food Industry R&D Associate",
      "Private Practice Nutrition Consultant",
    ],
  },
  curriculumStructure: {
    label: "WHAT YOU WILL LEARN",
    heading: "Curriculum Structure",
    description:
      "The curriculum blends strong biomedical and food science foundations with intensive clinical training and industry-integrated modules, ensuring students gain real-world nutrition and dietetics experience throughout their degree.",
    semesters: [
      {
        name: "Semester 1",
        title: "Building Foundations in Nutrition, Food Science and Human Health",
        description: "The first semester introduces students to the fundamental principles of nutrition, food science, and human health. Learners develop an understanding of human anatomy and physiology, nutritional concepts, food composition, and the relationship between diet and well-being. The curriculum also explores environmental influences on food systems, traditional Indian knowledge related to nutrition, and essential digital and communication skills. Together, these subjects establish a strong scientific and professional foundation for advanced studies in nutrition and dietetics.",
        subjects: [
          { name: "Fundamentals of Nutrition", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Human Anatomy and Physiology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Basics of Food Science", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Environmental Science", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Indian Knowledge System on Foods", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Computer Literacy", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "English for Communication", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
        ]
      },
      {
        name: "Semester 2",
        title: "Advancing Nutritional Sciences and Health Assessment",
        description: "The second semester strengthens students' understanding of the scientific principles that influence nutrition, health, and human development. Through the study of biochemistry, food microbiology, and nutrition across different stages of life, learners gain insights into the biological and nutritional needs of diverse populations. The curriculum also introduces nutritional assessment techniques, behavioural aspects of healthcare, and professional communication skills, enabling students to develop a holistic approach to nutrition planning, health promotion, and patient care.",
        subjects: [
          { name: "Food Microbiology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Fundamentals of Biochemistry", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Nutrition Through Life Cycle", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Psychology and Sociology Applied to Health Care", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Techniques of Nutritional Assessment", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Soft Skills and Communication", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Computer Literacy for Nutrition", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
        ]
      },
      {
        name: "Semester 3",
        title: "Developing Expertise in Applied Nutrition and Food Systems",
        description: "The third semester focuses on the relationship between food, nutrition, and health, enabling students to develop a deeper understanding of nutrient functions and dietary interventions. Learners explore the role of macronutrients in human nutrition, advanced food science concepts, and public health nutrition strategies that address community health needs. The curriculum also introduces the principles of medical nutrition therapy, food processing, preservation techniques, and advanced biochemistry, helping students build the scientific and practical competencies required for nutrition assessment, planning, and healthcare applications.",
        subjects: [
          { name: "Macronutrients in Human Nutrition", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Advanced Food Science", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Public Health Nutrition", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Basics of Medical Nutrition Therapy – Theory and Practical", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Advanced Biochemistry", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Food Processing and Preservation", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" }
        ]
      },
      {
        name: "Semester 4",
        title: "Applying Nutrition Science to Health, Disease and Public Well-Being",
        description: "The fourth semester focuses on the role of nutrition in disease prevention, management, and public health. Students gain an understanding of clinical biochemistry, pathophysiological processes, and the nutritional implications of various health conditions. The curriculum explores national nutrition policies, micronutrient requirements, functional foods, nutraceuticals, and advanced dietetics, enabling learners to develop evidence-based approaches to nutritional care. Emphasis is also placed on food safety standards and regulatory practices, preparing students to contribute effectively to clinical, community, and food service settings.",
        subjects: [
          { name: "Clinical Biochemistry and Pathophysiology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "National Health and Nutrition Programs and Policies", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Micronutrients in Human Nutrition", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Functional Foods and Nutraceuticals", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Advanced Dietetics", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Food Safety and Standards", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" }
        ]
      },
      {
        name: "Semester 5",
        title: "Advancing Specialized Nutrition Practice and Research Skills",
        description: "The fifth semester equips students with advanced knowledge in nutrition research, assessment, and specialized dietary applications. Learners explore sports nutrition, nutritional epidemiology, and counselling techniques that support evidence-based nutrition interventions across diverse populations. The curriculum also focuses on food analysis, research methodology, and emerging trends in nutrition and dietetics, enabling students to critically evaluate nutritional challenges and develop effective strategies for health promotion, disease prevention, and professional practice in evolving healthcare environments.",
        subjects: [
          { name: "Research Methodology and Statistics", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Sports Nutrition", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Tools and Techniques for Nutrition Counselling", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Nutritional Epidemiology and Anthropology", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Food Analysis", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Emerging Concepts in Nutrition and Dietetics", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" }
        ]
      },
      {
        name: "Semester 6",
        title: "Driving Community Nutrition and Sustainable Food Innovation",
        description: "The sixth semester focuses on the application of nutrition science in community settings, public health initiatives, and sustainable food systems. Students develop an understanding of nutrition health promotion strategies, behaviour change communication, and the role of sustainable practices in ensuring long-term food security and population well-being. The curriculum also emphasizes field-based learning, food product development, and case study analysis, enabling learners to apply theoretical knowledge to real-world challenges while strengthening their problem-solving, innovation, and community engagement skills.",
        subjects: [
          { name: "Social Behaviour Change Communication / Nutrition Health Promotion", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Sustainable Food Systems", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Field Practice in Public Health and Nutrition", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Food Product Development", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Case Study Reviews", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" }
        ]
      },
      {
        name: "Semester 7",
        title: "Preparing for Advanced Dietetic Practice and Professional Leadership",
        description: "The seventh semester focuses on advanced applications of nutrition and dietetics in clinical, emergency, and organizational settings. Students explore the nutritional management of critically ill patients, emergency nutrition interventions, and the administrative aspects of dietetic services. The curriculum also introduces entrepreneurship and information technology, enabling learners to adapt to evolving healthcare environments and emerging professional opportunities. Through applied dietetics and internship-based projects, students integrate their academic knowledge with practical experience, strengthening their readiness for professional practice and leadership roles in nutrition and healthcare.",
        subjects: [
          { name: "Information Technology in Nutrition and Dietetics", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Entrepreneurship in Nutrition and Dietetics", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Nutrition in Critically Ill Patients", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Management and Administration in Dietetic Services", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Nutrition in Emergencies", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Applied Dietetics / Internship Project", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" }
        ]
      },
      {
        name: "Semester 8",
        title: "Transitioning to Professional Nutrition and Dietetics Practice",
        description: "The final semester provides students with extensive practical exposure through experiential learning in hospital and healthcare settings. Learners apply their knowledge of clinical nutrition, diet planning, patient counselling, and healthcare practices while working alongside professionals in real-world environments. The curriculum also emphasizes research, scientific inquiry, and professional communication, enabling students to stay informed about emerging trends and contribute to evidence-based nutrition practice. This phase helps consolidate academic learning and prepares graduates for successful careers in nutrition and dietetics.",
        subjects: [
          { name: "Internship in Hospital Experiential Learning (6 Months / 1 Semester)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Research and Trends in Nutrition and Dietetics", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Scientific Writing in Nutrition and Dietetics", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" }
        ]
      },
      {
        name: "Value Addition",
        title: "Value-Added Learning Opportunities",
        description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
        "keySubjectsLabel": "Key Features",
        subjects: [
          { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
          { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
          { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
          { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
        ],
        "learningOutcomes": [
          "Gain real-world experience through the Red.Health Network internship",
          "Execute industry-based projects in healthcare settings",
          "Complete a capstone project and dissertation",
          "Transition confidently into healthcare management roles",
          "Prepare professionally through CV launch and career readiness activities"
        ]
      }
    ],
  },

  faq: {
    id: 103,
    title: "Bachelor of Nutrition & Dietetics",
    FAQ: [
      {
        id: 1,
        Question: "What is the university's role and what is Emversity's role?",
        Answer:
          "MSU manages all academic matters — admissions, examinations, marksheets, transcripts, and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance, and the Cambridge English program. Emversity does not collect fees, conduct exams, or award degrees.",
      },
      {
        id: 2,
        Question: "Is placement or internship stipend guaranteed?",
        Answer:
          "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution.",
      },
      {
        id: 3,
        Question: "Is this program recognised, and is it full-time?",
        Answer:
          "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university.",
      },
      {
        id: 4,
        Question: "How do I apply?",
        Answer:
          "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details, and application deadlines, please contact the MSU admissions office directly.",
      },
      {
        id: 5,
        Question: "What is the Head Start Programme?",
        Answer:
          "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing, and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships.",
      },
      {
        id: 6,
        Question: "Is this programme NCAHP aligned?",
        Answer:
          "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university's official academic notifications for the latest syllabus.",
      },
    ],
  },

  coursePrice: { price: "₹8,00,000" },
};
